import * as React from "react";
import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "../../lib/utils";

function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        months: "flex flex-col sm:flex-row gap-2",
        month: "flex flex-col gap-4",
        month_caption: "flex justify-center pt-1 px-10 relative items-center gap-2",
        caption_label: "text-sm font-medium select-none",
        dropdowns: "flex items-center gap-1.5 text-sm font-medium",
        dropdown: "absolute inset-0 opacity-0 cursor-pointer",
        dropdown_root: "relative inline-flex items-center gap-1 rounded-md border border-input bg-white px-2 py-0.5 hover:bg-accent has-focus:ring-1 has-focus:ring-ring",
        nav: "flex items-center gap-1",
        button_previous: "absolute left-2 top-1 z-10 h-7 w-7 bg-transparent p-0 opacity-70 hover:opacity-100 inline-flex items-center justify-center rounded-md border border-input pointer-events-auto",
        button_next: "absolute right-2 top-1 z-10 h-7 w-7 bg-transparent p-0 opacity-70 hover:opacity-100 inline-flex items-center justify-center rounded-md border border-input pointer-events-auto",
        month_grid: "w-full border-collapse space-y-1",
        weekdays: "flex",
        weekday: "text-muted-foreground rounded-md w-8 font-normal text-[0.8rem]",
        week: "flex w-full mt-2",
        day: "relative p-0 text-center text-sm focus-within:relative focus-within:z-[1] [&:has([aria-selected])]:bg-accent [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected].day-range-end)]:rounded-r-md",
        day_button: "h-8 w-8 p-0 font-normal aria-selected:opacity-100 rounded-md hover:bg-accent hover:text-accent-foreground focus-visible:ring-1 focus-visible:ring-ring",
        selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        today: "bg-accent text-accent-foreground",
        outside: "day-outside text-muted-foreground opacity-50",
        disabled: "text-muted-foreground opacity-50",
        range_end: "day-range-end",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, className: cClass, ...rest }) => {
          const cls = cn("h-4 w-4", cClass);
          if (orientation === "left") return <ChevronLeft className={cls} {...rest} />;
          if (orientation === "down") return <ChevronDown className={cls} {...rest} />;
          return <ChevronRight className={cls} {...rest} />;
        },
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar";

export { Calendar };
